import translate from "@/i18n/translate";
import { ParticipationOverviewInterface } from "./Sll";

interface ParticipationOverviewProps {
  overview: ParticipationOverviewInterface | null;
  reportingYear: string;
}

export default function ParticipationOverview(
  props: ParticipationOverviewProps
) {
  const { overview } = props;
  return (
    <div className="participation-section">
      <div className="participation-text">
        {translate("app.participationOverview.participationOverview")}
      </div>
      <div className="participation-overview-container-html">
        <div className="participation-overview-container">
          <div className="count">{overview?.orgCount}</div>
          <div className="label">
            {translate("app.participationOverview.orgPrograms", {
              reportingYear: props.reportingYear
            })}
          </div>
        </div>
        <div className="participation-overview-container">
          <div className="count">{overview?.assessmentCount}</div>
          <div className="label">
            {translate("app.participationOverview.commonAssessments")}
          </div>
        </div>
        <div className="participation-overview-container">
          <div className="count">{overview?.studentCount}</div>
          <div className="label">
            {translate("app.participationOverview.studentsAssessed")}
          </div>
        </div>
      </div>
    </div>
  );
}
